import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface TimeInputWithAmPmProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export const TimeInputWithAmPm: React.FC<TimeInputWithAmPmProps> = ({
  label,
  value,
  onChange,
}) => {
  const [timeValue, setTimeValue] = useState("");
  const [isPm, setIsPm] = useState(false);

  useEffect(() => {
    if (value) {
      const parts = value.split(" ");
      if (parts.length === 2) {
        setTimeValue(parts[0]);
        setIsPm(parts[1] === "PM");
      }
    }
  }, [value]);

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 5) return;
    const newValue = e.target.value;
    setTimeValue(newValue);

    const period = isPm ? "PM" : "AM";
    onChange(`${newValue} ${period}`);

    if (e.target.value.length === 4 && !e.target.value.includes(":")) {
      const temp = e.target.value.split("");
      temp.splice(2, 0, ":");
      const formattedValue = temp.join("");
      setTimeValue(formattedValue);
      onChange(`${formattedValue} ${period}`);
    }
  };

  const handlePeriodChange = (pm: boolean) => {
    setIsPm(pm);

    const period = pm ? "PM" : "AM";
    onChange(`${timeValue} ${period}`);
  };

  return (
    <div className={styles.timeInputWrapper}>
      <label className={styles.fieldLabel}>{label}</label>
      <div className={styles.timeInputContainer}>
        <input
          type="text"
          className={styles.timeInput}
          value={timeValue}
          onChange={handleTimeChange}
          placeholder="0:00"
        />
        <div className={styles.amPmSwitchContainer}>
          <button
            className={classNames(styles.amPmSwitch, {
              [styles.active]: !isPm,
            })}
            onClick={() => handlePeriodChange(false)}
            type="button"
          >
            AM
          </button>
          <button
            className={classNames(styles.amPmSwitch, {
              [styles.active]: isPm,
            })}
            onClick={() => handlePeriodChange(true)}
            type="button"
          >
            PM
          </button>
        </div>
      </div>
    </div>
  );
};
